import dayjs from "dayjs";
import React, { PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Line,
  ComposedChart,
  Bar,
  LineChart,
  ReferenceLine,
  Scatter,
  Cell,
} from "recharts";
import nodata from '../../src/assets/images/no-data.png'

export default class Example extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() { }

  render() {


const graphData = this.props.fuelGraphData || {};
const refillData = this.props.fuelRefillData || [];

// Fuel readings
const fuelPoints = Object.values(graphData)
  .flat()
  .map(item => ({
    timestamp: item.timestamp,
    name: dayjs(item.timestamp).format("HH:mm"),
    fuelLine: Number(item.fuel || 0),
    refillfuel: 0,
  }));

// Keep first, last, and every 5th fuel point
const reducedFuelPoints = fuelPoints.filter((item, index, arr) => {
  if (index === 0 || index === arr.length - 1) return true;
  return index % 30 === 0;
});

// Map for quick lookup
const mergedMap = {};

// Add reduced fuel points
reducedFuelPoints.forEach(item => {
  const key = dayjs(item.timestamp).format("YYYY-MM-DD HH:mm");

  mergedMap[key] = {
    ...item,
    refillfuel: 0,
  };
});

// Add refill events (always keep them)
refillData.forEach(item => {
  const key = dayjs(item.timestamp).format("YYYY-MM-DD HH:mm");

  if (mergedMap[key]) {
    mergedMap[key].refillfuel = Number(item.refillfuel || 0);
  } else {
    mergedMap[key] = {
      timestamp: item.timestamp,
      name: dayjs(item.timestamp).format("HH:mm"),
      fuelLine: null,
      refillfuel: Number(item.refillfuel || 0),
    };
  }
});

// Final sorted data
const mergedData = Object.values(mergedMap).sort(
  (a, b) =>
    dayjs(a.timestamp).valueOf() -
    dayjs(b.timestamp).valueOf()
);

console.log(mergedData);
return mergedData.length > 0 ? (
  <ResponsiveContainer width="100%" height={250}>
  <ComposedChart data={mergedData}>
    <CartesianGrid stroke="#f5f5f5" />

    <XAxis
      dataKey="name"
      interval="preserveStartEnd"
    />

    <YAxis />

    <Tooltip
      labelFormatter={(label) => `Time: ${label}`}
    />

    <Bar
      dataKey="refillfuel"
      fill="green"
      barSize={50}
      name="Refill Fuel"
    />

    <Line
      type="monotone"
      dataKey="fuelLine"
      stroke="#8884d8"
      strokeWidth={2}
      dot={false}
      connectNulls
      name="Fuel Level"
    />
  </ComposedChart>
</ResponsiveContainer>
) : (
  <div
    style={{
      height: 200,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    }}
  >
    <img
      src={nodata}
      alt="No Data"
      style={{ width: 120, opacity: 0.7 }}
    />
    <p>No graph data available</p>
  </div>
);      

    
  }
}
